<template>
  <div class="d-flex">
    <v-autocomplete
      class="original-selectbox mr-2"
      v-model="changedValue.countryCode"
      :items="items"
      :placeholder="getPlaceholderCode"
      dense
      item-text="label"
      item-value="value"
      :height="height"
      outlined
      style="width: 50%"
      hide-details
      return-object
      :disabled="disabled"
      :filled="disabled"
      :no-data-text="$t('common.common_no-data')"
    />
    <v-text-field
      v-model="inputedValue.phoneNumber"
      :placeholder="getPlaceholderPhone"
      dense
      :height="height"
      outlined
      style="width: 50%"
      hide-details
      :disabled="disabled"
      :filled="disabled"
    ></v-text-field>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

// 幅は親コンポで調整
export default {
  name: 'PhoneNumberInput',
  props: {
    value: {
      countryCode: {
        label: '+81',
        value: 1
      },
      phoneNumber: ''
    },

    height: { default: '32px' },
    placeholderCode: { default: 'common.input_please-select' },
    placeholderPhone: { default: 'common.input_input_1' },
    mode: { default: 1 },
    disabled: { default: false }
  },
  data: () => {
    return {
      selectedItem: '',
      outlined: true,
      filled: false,
      phoneNumber: '',
      text: '',
      ret: {},

      items: { label: '+81', value: 1 }
    }
  },
  created() {
    let list = this.getCountryCallingCodeListFromState()
    list.sort((countryCallingCode1, countryCallingCode2) => {
      if (countryCallingCode1.countryName < countryCallingCode2.countryName) {
        return -1
      } else if (
        countryCallingCode1.countryName > countryCallingCode2.countryName
      ) {
        return 1
      } else {
        return 0
      }
    })

    // 日本と中国のみ先頭に再配置
    const japaneseIndex = list.findIndex((countryCallingCode) => {
      return countryCallingCode.countryId === 88
    })
    const japaneseObject = list[japaneseIndex]
    const chineseIndex = list.findIndex((countryCallingCode) => {
      return countryCallingCode.countryId === 33
    })
    const chineseObject = list[chineseIndex]
    list.splice(japaneseIndex, 1)
    list.splice(chineseIndex, 1)
    list.unshift(japaneseObject, chineseObject)

    this.items = list.map((ele) => {
      return {
        label: ele.countryName + '(+' + ele.code + ')',
        value: ele.countryId
      }
    })
  },
  methods: {
    ...mapGetters('Common', ['getCountryCallingCodeListFromState'])
  },
  computed: {
    getPlaceholderPhone() {
      return this.$t(this.placeholderPhone)
    },
    getPlaceholderCode() {
      return this.$t(this.placeholderCode)
    },
    inputedValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    },
    changedValue: {
      get() {
        return this.value
      },
      set(newValue) {
        if (!newValue) {
          newValue = {
            label: '',
            value: null
          }
        }

        this.$emit('change', newValue)
      }
    }
  }
}
</script>
